// 單位介紹頁面
import React from "react";
import { StaffData, Staff } from "./staff-data";
export const Bilingual = () => {

  return (
    <div className="mb-16">
      <div className="flex items-center staticBanner bg-[#eac7a3] relative">
        <div className="staticBannerContent">
          <img
            src="/images/unitBanner.png"
            alt="banner"
            className="staticBannerImg"
          />
          <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] -translate-x-1/4 max-h-full">
            <h2 className=" font-black text-primaryDark">雙語學習推動辦公室</h2>
            <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
              為全面推動中小學數位學習精進方案，協助學校提高數位教學與學習品質及成效，高雄市政府教育局成立數位學習推動辦公室。
            </p>
          </div>
        </div>
      </div>
      <div className="staticSection">
        <div className="sectionContent">
          <h3 className="sectionTitle text-Headline">職掌分工</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-evenly">
            {StaffData.filter((staff) => staff.group === "X").map(
              (staff: Staff, index: number) => (
                <div
                  key={index}
                  className={`workCard relative text-base cardType-${staff.cardType}`}
                >
                  <div className="workCardLeft text-white text-sm leading-normal space-y-1">
                    <h3 className="text-xl">{staff.name}</h3>
                    <p>{staff.role}</p>
                    <p>{staff.title}</p>
                    <p>{staff.phone}</p>
                    <p className="break-words">{staff.email}</p>
                  </div>
                  <div className="workCardRight absolute right-0 w-1/2 hover:w-full text-sm leading-normal">
                    <ul className="max-h-full absolute p-2 list-disc ps-[1.8em] text-left overflow-x-hidden space-y-1">
                      {staff.workItem.map((item, idx) => (
                        <li key={idx} className="break-words">
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <div className='p-7 lg:p-16'></div>
    </div>
  );
};
